import { InfoIcon } from "lucide-react";
import * as React from "react";

import {
  fieldErrorClassName,
  fieldLabelRowClassName,
  fieldOptionalMarkerClassName,
  fieldWrapperClassName,
} from "@/components/ui/form-field-styles";
import { Label } from "@/components/ui/label";
import { cn } from "@/lib/utils";

function Textarea({
  className,
  label,
  error,
  isOptional,
  id: idProp,
  ...props
}: React.ComponentProps<"textarea"> & {
  label?: string;
  error?: string | false | null | undefined;
  isOptional?: boolean;
}) {
  const generatedId = React.useId();
  const id = idProp ?? generatedId;
  const textarea = (
    <textarea
      id={id}
      data-slot="textarea"
      aria-invalid={Boolean(error) || props["aria-invalid"]}
      aria-describedby={error ? `${id}-error` : props["aria-describedby"]}
      className={cn(
        "border-input bg-input/20 placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-ring/30 aria-invalid:border-destructive aria-invalid:ring-destructive/20 dark:bg-input/30 dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40 flex field-sizing-content min-h-16 w-full resize-none rounded-md border px-3 py-2 text-base transition-colors outline-none focus-visible:ring-2 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:ring-2 sm:text-sm",
        className,
      )}
      {...props}
    />
  );

  if (!label && !error && !isOptional) {
    return textarea;
  }

  return (
    <div className={fieldWrapperClassName}>
      {label && (
        <div className={fieldLabelRowClassName}>
          <Label htmlFor={id}>{label}</Label>
          {isOptional && <span className={fieldOptionalMarkerClassName}>Opcional</span>}
        </div>
      )}
      {textarea}
      {error && (
        <div className={fieldErrorClassName} id={`${id}-error`}>
          <InfoIcon aria-hidden="true" className="size-3.5" />
          {error}
        </div>
      )}
    </div>
  );
}

export { Textarea };
